<template>
  <div class="mx-3">
    <v-row>
      <v-col
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <setup-leaves-leave-type-dialog-create
          v-if="$hasPermissionTo(['create leave types'])"
          :combined-leave-types="combinedLeaveTypes"
          @created="loadData"
        />
      </v-col>
      <v-spacer />

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-select
          v-model="statusFilter"
          :items="items"
          item-text="state"
          item-value="value"
          label="Leave Type's Status"
          placeholder="Active / Deleted"
        />
      </v-col>

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-text-field
          v-model="search"
          placeholder="Key in leave type here"
          append-icon="search"
          label="Search Leave Type"
          hide-no-data
          hide-selected
          clearable 
        />
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="filteredLeaveTypes"
      :loading="tableLoading"
      :search="search"
    >
      <template v-slot:item.name="{ item }">
        <div>
          <span>
            {{ item.name }}
          </span>
        </div>
      </template>
      <template v-slot:item.is_paid_leave="{ item }">
        <div>
          <span>
            <v-icon
              v-if="item.is_paid_leave"
              color="hrissecondary"
            >
              mdi-check-outline
            </v-icon>
            <v-icon
              v-else
              color="error"
            >
              mdi-close-outline
            </v-icon>
          </span>
        </div>
      </template>
      <template v-slot:item.is_prorated="{ item }">
        <div>
          <span>
            <v-icon
              v-if="item.is_prorated"
              color="hrissecondary"
            >
              mdi-check-outline
            </v-icon>
            <v-icon
              v-else
              color="error"
            >
              mdi-close-outline
            </v-icon>   
          </span>
        </div>
      </template>
      <template v-slot:item.is_bi_yearly="{ item }">
        <div>
          <span>
            <v-icon
              v-if="item.is_bi_yearly"
              color="hrissecondary"
            >
              mdi-check-outline
            </v-icon>
            <v-icon
              v-else
              color="error"
            >
              mdi-close-outline
            </v-icon>   
          </span>
        </div>
      </template>
      <template v-slot:item.is_carry_forwardable="{ item }">
        <div>
          <span>
            <v-icon
              v-if="item.is_carry_forwardable"
              color="hrissecondary"
            >
              mdi-check-outline
            </v-icon>
            <v-icon
              v-else
              color="error"
            >
              mdi-close-outline
            </v-icon> 
          </span>
        </div>
      </template>
 
      <template v-slot:item.is_continuous="{ item }">
        <div>
          <span>
            <v-icon
              v-if="item.is_continuous"
              color="hrissecondary"
            >
              mdi-check-outline
            </v-icon>
            <v-icon
              v-else
              color="error"
            >
              mdi-close-outline
            </v-icon>
          </span>
        </div>
      </template>
      <template v-slot:item.requires_confirmation="{ item }">
        <div>
          <span>
            <v-icon
              v-if="item.requires_confirmation"
              color="hrissecondary"
            >
              mdi-check-outline
            </v-icon>
            <v-icon
              v-else
              color="error"
            >
              mdi-close-outline
            </v-icon>   
          </span>
        </div>
      </template>
      <template v-slot:item.requires_document="{ item }">
        <div>
          <span>
            <v-icon
              v-if="item.requires_document"
              color="hrissecondary"
            >
              mdi-check-outline
            </v-icon>
            <v-icon
              v-else
              color="error"
            >
              mdi-close-outline
            </v-icon>   
          </span>
        </div>
      </template>

      <template v-slot:item.is_optional_leave_entitlement="{ item }">
        <div>
          <span>
            <v-icon
              v-if="item.is_optional_leave_entitlement"
              color="hrissecondary"
            >
              mdi-check-outline
            </v-icon>
            <v-icon
              v-else
              color="error"
            >
              mdi-close-outline
            </v-icon>
          </span>
        </div>
      </template>

      <template v-slot:item.requires_reason="{ item }">
        <div>
          <span>
            <v-icon
              v-if="item.requires_reason"
              color="hrissecondary"
            >
              mdi-check-outline
            </v-icon>
            <v-icon
              v-else
              color="error"
            >
              mdi-close-outline
            </v-icon>

            <span
              v-if="item.requires_reason && item.minimum_days_reason_required"
              class="font-weight-bold"
            >
              ({{ item.minimum_days_reason_required }})
            </span>
          </span>
        </div>
      </template>
      <template v-slot:item.notify_hr="{ item }">
        <div>
          <span>
            <v-icon
              v-if="item.notify_hr"
              color="hrissecondary"
            >
              mdi-check-outline
            </v-icon>
            <v-icon
              v-else
              color="error"
            >
              mdi-close-outline
            </v-icon>
          </span>
        </div>
      </template>
      <template v-slot:item.action="{ item }">
        <span v-if="statusFilter">
          <setup-leaves-leave-type-dialog-edit
            v-if="$hasPermissionTo(['update leave types'])"
            :leave-type="item"
            @updated="loadData"
          />
          <setup-leave-leave-type-dialog-delete
            v-if="$hasPermissionTo(['delete leave types'])"
            :leave-type="item"
            @deleted="loadData"
          />
        </span>
        <span v-else>
          <setup-leave-leave-type-dialog-restore
            v-if="$hasPermissionTo(['restore leave types'])"
            :leave-type="item"
            @restored="loadData"
          />
        </span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  export default {
    components: {
      SetupLeavesLeaveTypeDialogCreate: () => import('@/components/hris/setup/leaves/leave-type/DialogCreate'),
      SetupLeavesLeaveTypeDialogEdit: () => import('@/components/hris/setup/leaves/leave-type/DialogEdit'),
      SetupLeaveLeaveTypeDialogDelete: () => import('@/components/hris/setup/leaves/leave-type/DialogDelete'),
      SetupLeaveLeaveTypeDialogRestore: () => import('@/components/hris/setup/leaves/leave-type/DialogRestore'),
    },
    data () {
      return {
        leaveTypes: [],
        trashedLeaveTypes: [],
        headers: [
          {
            text: 'Leave Types',
            align: 'left',
            value: 'name',
          },
          {
            text: 'Paid Leave',
            align: 'center',
            value: 'is_paid_leave',
            sortable: false,
          },
          {
            text: 'Prorated?',
            align: 'center',
            value: 'is_prorated',
            sortable: false,
          },
          {
            text: 'Bi-Yearly?',
            align: 'center',
            value: 'is_bi_yearly',
            sortable: false,
          },
          {
            text: 'Carry Forward?',
            align: 'center',
            value: 'is_carry_forwardable',
            sortable: false,
          },
          {
            text: 'Is Continuous?',
            align: 'center',
            value: 'is_continuous',
            sortable: false,
          },
          {
            text: 'Requires Confirmation',
            align: 'center',
            value: 'requires_confirmation',
            sortable: false,
          },
          {
            text: 'Requires Document',
            align: 'center',
            value: 'requires_document',
            sortable: false,
          },
          {
            text: 'Is Optional Entitlement?',
            align: 'center',
            value: 'is_optional_leave_entitlement',
            sortable: false,
          },
          {
            text: 'Requires Reason (Days)',
            align: 'center',
            value: 'requires_reason',
            sortable: false,
          },
          {
            text: 'Notify HR?',
            align: 'center',
            value: 'notify_hr',
            sortable: false,
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
        search: '',
        statusFilter: { state: 'Active', value: true },
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
        tableLoading: true,
        combinedLeaveTypes: [],
      }
    },
    computed: {
      filteredLeaveTypes () {
        return this.statusFilter ? this.leaveTypes : this.trashedLeaveTypes
      },
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        Promise.all([
          this.$api.hrisLeaveTypes().list(),
          this.$api.hrisLeaveTypes().listTrashed(),
        ]).then(([leaveTypes, trashedLeaveTypes]) => {
          this.leaveTypes = leaveTypes.data
          this.trashedLeaveTypes = trashedLeaveTypes.data

          this.combinedLeaveTypes = leaveTypes.data.concat(trashedLeaveTypes.data)

          this.tableLoading = false
        })
      },
    },
  }
</script>
